module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/sarigenai_naminori_yutousei-fe64f3e798c1528a6b165b021289a023.png";